import { useQuery } from "@tanstack/react-query";
import { fetchQuotes } from "../lib/api";
import { queryKeys } from "../lib/queryKeys";

export function useQuotes() {
	return useQuery({
		queryKey: queryKeys.quotes,
		queryFn: fetchQuotes,
	});
}
